import {
	Column,
	Format
} from 'devextreme-react/data-grid';

import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { PaymentScheduleDetaisParams } from '../types/PaymentScheduleDetailsParams';
import { useGetPaymentScheduleDetails } from '../api/get-payment-schedule-details';

export default function PaymentScheduleDetailsGrid(props: PaymentScheduleDetaisParams) {

	const details = useGetPaymentScheduleDetails(props);

	return (
		<>
			<SyncDataGrid
				stateStorageKey='payment-schedule-grid'
				className="dx-card wide-card"
				dataSource={details.data?.records}
				keyExpr={['priceBucketItemID']}
			>
				<Column
					dataField={'sku'}
					caption={'SKU'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'description'}
					caption={'Description'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'productType'}
					caption={'Product Type'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'uom'}
					caption={'UOM'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'amount'}
					caption={'Amount'}
					dataType="number"
					alignment="center"
					editorOptions={{ format: '$#,##0.##', showClearButton: true }}
				>
					<Format
						type="currency"
						precision={2}
					/>
				</Column>
			</SyncDataGrid>

			<LoadPagePanel visible={details.isLoading} />
		</>
	)
} 
